import { processLexientityContent } from 'views/App/Portal/Policy/DraftManuals/utils/textEntityProcessor';
import type { TextEntity } from 'views/App/Portal/Policy/DraftManuals/utils/textEntityProcessor';
import ContentConversionHelper, { type ContentConversionConfig } from 'views/App/Portal/Policy/DraftManuals/helpers/contentConversionHelper';

/**
 * Prepares content for display by resolving lexientity elements with GIQ values
 * and applying content conversion for rendering.
 * Runs contentForRender first to normalize span.text-entity to lexientity, then
 * substitutes with resolved values (preserving text-entity styling).
 * @param content - The HTML content (may contain lexientity or span.text-entity)
 * @param textEntities - Array of text entities with resolved values (from GIQ/custom)
 * @param options - Optional config passed to contentConversionHelper.contentForRender
 * @returns Processed content ready for parse()/display
 */
export function getContentForDisplay(
  content: string,
  textEntities: TextEntity[] | undefined,
  options?: ContentConversionConfig
): string {
  const normalizedContent = ContentConversionHelper.contentForRender(content ?? '', options);
  return processLexientityContent(normalizedContent, textEntities ?? []);
}
